import React from "react";
import { Button, Columns, Field, Modal, Section } from "@allxsmith/bestax-bulma";
import useInput from "../../hooks/useInput";

export default function MultiplePartStockEditModal({
  open,
  setOpen,
  selected,
  saveSelected
}) {
  const [partName, partNameInput, setPartName] = useInput({
    type: "text",
    label: "Part Name"
  });
  const [partCost, partCostInput, setPartCost] = useInput({
    type: "number",
    label: "Part Cost",
    currency: true
  });
  const [partNumber, partNumberInput, setPartNumber] = useInput({
    type: "text",
    label: "Part Number"
  });
  const [stockVolume, stockVolumeInput, setStockVolume] = useInput({
    type: "number",
    label: "Stock Volume",
  });

  const onSave = () => {
    saveSelected(partName, partCost, partNumber, stockVolume).then(onClose);
  };

  const onClose = () => {
    setOpen(false);
    setPartName("");
    setPartCost("");
    setPartNumber("");
    setStockVolume("");
  };

  // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
  return (
    <Modal closeOnBlur active={open} onClose={onClose}>
      <Modal.Content>
        <Section style={{ backgroundColor: "white" }}>
          <Columns isMultiline>
            {partNameInput}
            {partCostInput}
            {partNumberInput}
            {stockVolumeInput}
          </Columns>
          <Field>
            <p>You are editing {Object.keys(selected).length} parts</p>
          </Field>
          <Button color="success" onClick={onSave}>
            Save
          </Button>
        </Section>
      </Modal.Content>
    </Modal>
  );
}
